export const SearchTypeExpiration = 17 as const;
export type TSearchTypeExpiration = typeof SearchTypeExpiration;
